import { render, staticRenderFns } from "./virtual-tryon.vue?vue&type=template&id=3a8d88b0"
import script from "./virtual-tryon.vue?vue&type=script&lang=js"
export * from "./virtual-tryon.vue?vue&type=script&lang=js"
import style0 from "./_vto.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports